/**
 * 栏目
 */
export enum ColumnsConfig {
  智慧社区 = "7004",
  街镇部门 = "7005.7018",
  党建 = "7004.7015",
  党建文化 = "7004.7015.7035",
  廉洁文化 = "7004.7015.7036",
  单位文化 = "7004.7015.7037",
  留言互动 = "7004.7015.7060",
  党员管理 = "7004.7016",
  社区活动 = "7004.7017",
  周边服务 = "7004.7049",
  全媒体 = "7005",
  铜梁融媒 = "7005.7050",
  外链 = "7005.7051",
  社区消息 = "7004.7053",
  办事服务 = "7001.7008.7030",
  政策发布 = "7001.7008.7030.7042",
  行政审批 = "7001.7008.7030.411",
  政务热线 = "7001.7008.7030.409"
}

/**
 * 模板编码
 */
export enum TempletCode {
  NEWS_NOMAR = "NEWS_NOMAR",
  NOMAL_LINK = "NOMAL_LINK",
  INDEX_PLF = "INDEX_PLF"
}
